<template>
    <g>
        <g>
            <path :style="{ fill: color }" d="M56.5,62.8c0.4,0.3-1.2,0-2.6,0c-1.4,0-2.8,0.2-2.6,0c0.3-0.2,1.2-0.7,2.6-0.7
		C55.3,62.1,56.2,62.5,56.5,62.8z"/>
            <path :style="{ fill: color }" d="M58.9,59.5c-0.6,0-2.1-0.7-3.1-0.7c-1,0-1.9,0.3-2,0.4c-0.1-0.1-1.2-0.4-2.1-0.4c-1,0-2.4,0.7-3,0.7
		c-0.6,0-0.8-0.2-0.8-0.2s0,0.3,0.1,0.4c0.6,0.4,1.7-0.1,3,0c1.1,0,1.9,0.3,2.9,0.4c0,0,0.1,0,0.1,0c1-0.1,1.7-0.3,2.9-0.4
		c1.3,0,2.4,0.4,3,0c0.1-0.1,0.1-0.4,0.1-0.4S59.6,59.5,58.9,59.5z"/>
        </g>
        <path :style="{ fill: color }" d="M63.2,68.1c-0.1-1.4-1.1-2-1.3-2.1s-0.8-0.3-1.3-0.4c-0.5-0.2-1.6-0.6-2.5-1.2
        c-0.6-0.5-2.3-0.5-3.4-0.4c-0.3,0-0.6,0.1-0.9,0.1c0,0,0,0,0,0l0,0h0l0,0c0,0,0,0,0,0c-0.3,0-0.6,0-0.9-0.1c-1.1,0-2.8,0-3.4,0.4
        c-0.9,0.7-2,1.1-2.5,1.2c-0.5,0.2-1,0.3-1.3,0.4s-1.2,0.7-1.3,2.1c0,0,0,0,0,0c0,0.4,0.1,0.8,0.1,0.8s0.2,0.8,0.6,1.8
        c0.5,0.9,1,1.4,1.4,1.9c0.3,0.4,0.9,1.5,2.4,2.1c1.7,0.6,3.3,0.9,5,1v0l0,0c1.6-0.1,3.3-0.4,5-1c1.4-0.6,2-1.7,2.4-2.1
        c0.4-0.5,0.9-1,1.4-1.9c0.5-0.9,0.6-1.8,0.6-1.8S63.1,68.5,63.2,68.1C63.2,68.1,63.2,68.1,63.2,68.1z"/>
    </g>
</template>

<script>
    import Mouth from './Mouth';

    export default {
        name: 'Mouth2',
        mixins: [Mouth],
    }
</script>
